import { ImageIcon, ViewVerticalIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrelViewerContext } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React from 'react'

// Submenu button that switches between floating and docked photo reel modes
export const DockPhotoReelButton: React.FC = () => {
  const {
    setPhotoReelDocked,
    setPhotoReelOpen,
    photoReelMode,
    setPhotoReelMode,
    setSelectedPhoto,
  } = useKestrelViewerContext()

  const handleClick = () => {
    if (photoReelMode === 'docked') {
      // Switch to floating mode
      setSelectedPhoto(null)
      setPhotoReelMode('floating')
      setPhotoReelDocked(false)
      setPhotoReelOpen(true)
    } else {
      // Switch to docked mode
      setPhotoReelMode('docked')
      setPhotoReelOpen(false)
      setPhotoReelDocked(true)
    }
  }

  // Show the other icon
  const icon =
    photoReelMode === 'docked' ? (
      <ImageIcon width={22} height={22} color='white' />
    ) : (
      <ViewVerticalIcon width={22} height={22} color='white' />
    )

  const label =
    photoReelMode === 'docked' ? 'Floating Photo Reel' : 'Dock Photo Reel'

  return (
    <TooltipWrapper side={'top'} offset={5} label={label}>
      <ViewToggle onClick={handleClick} selected={false}>
        {icon}
      </ViewToggle>
    </TooltipWrapper>
  )
}
